var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,40c-4,0-7.8-1.2-11.1-3.4c-3.3-2.2-5.9-5.3-7.4-9C0,24-0.4,20,0.4,16.1c0.8-3.9,2.7-7.4,5.5-10.2s6.4-4.7,10.2-5.5 C20-0.4,24,0,27.7,1.5c3.7,1.5,6.8,4.1,9,7.4C38.8,12.2,40,16.1,40,20c0,5.3-2.1,10.4-5.9,14.1C30.4,37.9,25.3,40,20,40L20,40z  M20,2.5c-3.5,0-6.9,1-9.8,2.9s-5.1,4.7-6.5,7.9s-1.7,6.7-1,10.1s2.3,6.5,4.8,9c2.5,2.5,5.6,4.1,9,4.8c3.4,0.7,6.9,0.3,10.1-1 c3.2-1.3,6-3.6,7.9-6.5c1.9-2.9,3-6.3,3-9.8c0-4.7-1.9-9.1-5.1-12.4C29.1,4.3,24.7,2.5,20,2.5L20,2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4,32.4L32,5.9l1.7,1.7L7.1,34.2L5.4,32.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrignal);
export default __webpack_public_path__ + "static/media/orignal.e0f81cc8.svg";
export { ForwardRef as ReactComponent };